<template>
  <v-checkbox
    v-bind="{ ...$attrs, ...$props, ...props }"
    class="e-checkbox"
    :hide-details="true"
    indeterminate-icon="icon-minus-sign"
    true-icon="icon-checkmark"
    false-icon="empty">
    <template v-for="(_, slot) in $slots" #[slot]="scope">
      <slot :name="slot" v-bind="scope || {}" />
    </template>
    <template v-if="$slots.label || label" #label>
      <slot name="label">
        <div class="e-checkbox__desc" :class="{ 'e-checkbox__desc--gap': props.labelDetails !== '' }">
          <div class="e-checkbox__desc__label">
            {{ label }}
          </div>
          <div class="e-checkbox__desc__details">
            {{ labelDetails }}
          </div>
        </div>
      </slot>
    </template>
  </v-checkbox>
</template>

<script setup>
import { VCheckbox } from 'vuetify/components/VCheckbox';

const props = defineProps({
  label: {
    type: String,
    default: '',
  },
  labelDetails: {
    type: String,
    default: '',
  },
})
</script>

<style lang="scss">
@import '../../scss/styles';
.e-checkbox {
  .v-label {
    opacity: 1;
  }
  &__desc {
    height: 100%;
    margin-left: 6px;
    display: flex;
    flex-direction: column;
    &--gap {
      gap: 4px;
    }
    &__label {
      @include body-3;
      margin-top: 2px;
      color: $graybase;
    }
    &__details {
      @include body-3;
      color: $grayscale400;
    }
  }
  .v-selection-control__wrapper {
    height: 24px;
    width: 24px;
  }
  .v-selection-control {
    align-items: flex-start;
    min-height: auto;
  }
  .v-selection-control__input {
    width: 20px;
    height: 20px;
    .v-icon {
      border: 1px solid $primary300;
      background: $primary300;
      overflow: hidden;
      border-radius: 6px;
      opacity: 1;
      font-size: 20px;
      color: $whitebase;
      &.empty {
        background: transparent;
        border-color: $grayscale300;
      }
    }
    &:hover {
      .v-icon {
        background: $primary400;
        border-color: $primary400;
        &.empty {
          background: transparent;
          border-color: $graybase;
        }
      }
    }
    &:before {
      content: none;
    }
  }
  .v-selection-control--focused {
    .v-selection-control__input {
      .v-icon {
        @include blue-ring;
      }
    }
  }
  .v-selection-control--disabled {
    opacity: 1;
    .v-selection-control__input {
      .v-icon {
        background: $grayscale300;
        border-color: $grayscale300;
        &.empty {
          background: transparent;
        }
      }
    }
    .e-checkbox__desc {
      &__details,
      &__label {
        color: $grayscale300;
      }
    }
  }
}
.v-theme--dark {
  .e-checkbox {
    &__desc {
      &__label {
        color: $grayscale100;
      }
      &__details {
        color: $grayscale400;
      }
    }

    .v-selection-control__input {
      .v-icon {
        &.empty {
          border-color: $grayscale600;
        }
      }

      &:hover {
        .v-icon {
          &.empty {
            border-color: $grayscale100;
          }
        }
      }
    }
    .v-selection-control--disabled {
      .v-selection-control__input {
        .v-icon {
          color: $grayscale600;
          background: $grayscale700;
          border-color: $grayscale700;
          &.empty {
            background: transparent;
          }
        }
      }
      .e-checkbox__desc {
        &__details,
        &__label {
          color: $grayscale700;
        }
      }
    }
  }
}
</style>
